/*
 *
 * Do not edit directly
 * Generated on Thu, 24 Apr 2025 18:51:19 GMT
 *
 */

import PaletteIconClose from '@telus-uds/palette-allium/build/rn/icons/Close'
import PaletteIconStatusInfo from '@telus-uds/palette-allium/build/rn/icons/StatusInfo'
import PaletteIconStatusSuccess from '@telus-uds/palette-allium/build/rn/icons/StatusSuccess'
import PaletteIconStatusWarning from '@telus-uds/palette-allium/build/rn/icons/StatusWarning'
import PaletteIconStatusError from '@telus-uds/palette-allium/build/rn/icons/StatusError'
const theme = {
  appearances: {
    style: {
      type: 'variant',
      values: [ 'system', 'success', 'warning', 'error', 'subtle' ]
    },
    system: { type: 'state', values: [ true ] },
    validation: {
      description: 'Validation states for form inputs',
      type: 'state',
      values: [ 'error', 'success', 'warning' ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { system: true },
      tokens: {
        borderLeftWidth: 0,
        borderRadius: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        iconGap: 8
      }
    },
    {
      if: { style: 'system' },
      tokens: {
        borderLeftWidth: 0,
        borderRadius: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        iconGap: 8
      }
    },
    {
      if: { style: 'subtle' },
      tokens: {
        borderBottomWidth: 0,
        borderLeftWidth: 0,
        borderRadius: 6,
        borderRightWidth: 0,
        borderTopWidth: 0,
        iconGap: 8
      }
    },
    {
      if: { style: 'success' },
      tokens: {
        backgroundColor: '#f4f9f2',
        borderColor: '#2b8000',
        icon: PaletteIconStatusSuccess,
        iconColor: '#2b8000'
      }
    },
    {
      if: { validation: 'success' },
      tokens: {
        backgroundColor: '#f4f9f2',
        borderColor: '#2b8000',
        icon: PaletteIconStatusSuccess,
        iconColor: '#2b8000'
      }
    },
    {
      if: { style: 'warning' },
      tokens: {
        backgroundColor: '#fff9ee',
        borderColor: '#b4872c',
        dismissIcon: null,
        icon: PaletteIconStatusWarning,
        iconColor: '#b4872c'
      }
    },
    {
      if: { validation: 'warning' },
      tokens: {
        backgroundColor: '#fff9ee',
        borderColor: '#b4872c',
        dismissIcon: null,
        icon: PaletteIconStatusWarning,
        iconColor: '#b4872c'
      }
    },
    {
      if: { style: 'error' },
      tokens: {
        backgroundColor: '#fff6f8',
        borderColor: '#e12339',
        dismissIcon: null,
        icon: PaletteIconStatusError,
        iconColor: '#e12339'
      }
    },
    {
      if: { validation: 'error' },
      tokens: {
        backgroundColor: '#fff6f8',
        borderColor: '#e12339',
        dismissIcon: null,
        icon: PaletteIconStatusError,
        iconColor: '#e12339'
      }
    }
  ],
  tokens: {
    backgroundColor: '#efedff',
    borderBottomWidth: 1,
    borderColor: '#7c53a5',
    borderLeftWidth: 1,
    borderRadius: 6,
    borderRightWidth: 1,
    borderTopWidth: 1,
    color: '#414547',
    containerPaddingLeft: 0,
    containerPaddingRight: 0,
    dismissButtonGap: 24,
    dismissIcon: PaletteIconClose,
    dismissIconColor: '#676e73',
    fontName: 'HNforTELUSSA',
    fontSize: 16,
    fontWeight: '400',
    icon: PaletteIconStatusInfo,
    iconColor: '#4b286d',
    iconGap: 8,
    iconSize: 24,
    justifyContent: 'flex-start',
    lineHeight: 1.5,
    paddingBottom: 12,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 12
  }
}
export default theme
